import * as actions from '../actions/actionTypes';

export const initialState = {
  formTemplates: {},
  formTemplateAllIds: [],
  formTemplateRequest: {
    requestType: null,
    error: {},
    loading: true,
  },
  defaultFormTemplate: undefined,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_FORM_TEMPLATE: {
      const mergeNewlyCreatedTemplate = {
        ...state.formTemplates,
        [action.value.id]: action.value,
      };

      return {
        ...state,
        formTemplates: mergeNewlyCreatedTemplate,
        formTemplateAllIds: [action.value.id, ...state.formTemplateAllIds],
      };
    }
    case actions.FETCH_FORM_TEMPLATES_SUCCESS: {
      const formTemplatesMap = new Map();
      const { formTemplates, defaultFormTemplate } = action;
      formTemplates.forEach((template) => {
        formTemplatesMap.set(template.id, template);
      });

      return {
        ...state,
        formTemplates: Object.fromEntries(formTemplatesMap),
        defaultFormTemplate: defaultFormTemplate,
      };
    }
    case actions.SET_FORM_TEMPLATES_ERROR: {
      const formTemplateRequestCopyError = {
        ...state.formTemplateRequest,
        error: action.payload.error,
        requestType: action.payload.requestType,
      };

      return { ...state, formTemplateRequest: formTemplateRequestCopyError };
    }
    case actions.SET_FORM_TEMPLATE_FETCH_REQUEST_LOADING: {
      const formTemplateRequestCopyLoading = {
        ...state.formTemplateRequest,
        loading: action.loading,
      };

      return { ...state, formTemplateRequest: formTemplateRequestCopyLoading };
    }
    case actions.SET_FORM_TEMPLATE_ALL_IDS:
      return { ...state, formTemplateAllIds: action.formTemplatesIds };

    case actions.UPDATE_FORM_TEMPLATE_REQUEST: {
      const mergeUpdatedFormTemplate = {
        ...state.formTemplates,
        [action.value.id]: action.value,
      };

      return { ...state, formTemplates: mergeUpdatedFormTemplate };
    }

    default:
      return state;
  }
}
